import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTrendingDown, FiShield, FiWifi, FiServer, FiActivity, FiUsers } = FiIcons;

const services = [
  {
    icon: FiTrendingDown,
    title: "Internet Cost Optimization",
    description: "We analyze your current ISP bills, compare providers across NYC, and negotiate better rates to significantly reduce your monthly internet costs without sacrificing speed."
  },
  {
    icon: FiWifi,
    title: "Ubiquiti UniFi Installations",
    description: "Expert deployment of enterprise-grade Ubiquiti access points, switches, and gateways to eliminate dead zones and ensure reliable, lightning-fast connectivity."
  },
  {
    icon: FiShield,
    title: "Secure Business WiFi",
    description: "Protect sensitive company data with advanced encryption, robust firewalls, and properly configured VLANs to isolate traffic and prevent unauthorized access."
  },
  {
    icon: FiUsers,
    title: "Branded Guest Networks",
    description: "Deploy secure, isolated guest WiFi with custom splash pages, bandwidth throttling, and seamless social or email login for marketing integration."
  },
  {
    icon: FiServer,
    title: "Infrastructure Upgrades",
    description: "Modernize outdated cabling, organize server racks, and replace aging hardware to build a scalable foundation for your business's future growth."
  },
  {
    icon: FiActivity,
    title: "Managed Network Support",
    description: "Ongoing proactive monitoring, cloud management, and rapid NYC-based support to resolve issues before they impact your daily operations."
  }
];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-brand-blue font-semibold tracking-wide uppercase text-sm mb-3">Comprehensive Solutions</h2>
          <h3 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6">Upgrade Your NYC Business Network</h3>
          <p className="text-lg text-slate-600">
            From lowering your ISP bills to designing robust wireless infrastructures, we deliver end-to-end networking solutions tailored for commercial environments.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
                <SafeIcon icon={service.icon} className="text-2xl text-blue-600 group-hover:text-white transition-colors duration-300" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">{service.title}</h4>
              <p className="text-slate-600 leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;